import { createAuthLink } from 'aws-appsync-auth-link';
import { ApolloLink } from '@apollo/client/core';
import { AwsConfiguration } from '../../ConfigContext/types';

export const authLink = (config: AwsConfiguration, tokenFn: () => string) => {
  return createAuthLink({
    url: config.graphQLEndpoint,
    region: config.region,
    auth: {
      type: 'AMAZON_COGNITO_USER_POOLS',
      jwtToken: tokenFn,
    },
  }) as unknown as ApolloLink;
};
